import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import Iframe from 'react-iframe';
import Select from "react-select";
import { alert_error, alert_success } from '../../AppContext';
function Rutgonlink() {
  const [amount, setamount] = useState("");
  const [inputmota, setinputmotat] = useState('');
  const [social, setSocial] = useState('');
  const [nutorder, setnutorder] = useState('Ấn đây để rút gọn');
  const [thanhcong2, setthanhcong2] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const [inputlienket, setinputlienket] = useState('');
  const [chedo, setchedo] = useState('');
  const [content, setcontent] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [service, setservice] = useState('');
  const [options, setoptions] = useState([
    {
      id: '', stt: '', name: 'Đang tải danh sách',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const handleOptionChange = (selectedOption) => {
    setIsOpen(false);
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      setchedo(selectedValue);
      const selectedOptionOk = options.find((option) => option.servicecode === selectedValue);
      setcontent(selectedOptionOk.content);
      setservice(selectedOptionOk);
      // Add other actions here based on the user's selection
    }
  };
  function gopdulieu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 cấp độ kiếm tiền',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions(arr1.concat(arr2));

  }
  function laydulieu() {
    axios
      .post('https://hust.media/link/load_users/service4.php', {
        category: 'urlshorten'
      })
      .then(response => gopdulieu(response))
      .catch(error => console.log(error))
  }
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0 || status == "error") {
      alert_error(info.message);
    }
    else if (status == 1 || status == "success") {
      alert_success(info.message);
      setthanhcong2(info.shortenedUrl);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!inputlienket) {
      alert_error('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/link/load_system/add_link.php', {
        lienket: inputlienket,
        apikey: apikey,
        mota: inputmota,
        chedo: chedo,
        money: amount
      })
      .then(response => (testFunction(response)))
      .catch(error => console.log(error))

  }

  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };

  useEffect(() => {
    // Thực hiện các hành động liên quan đến giá trị đã chọn tại đây
  }, [social]);
  useEffect(() => {
    laydulieu();


  }, []);


  return (
    <>
      <Helmet>
        <title> Website Rút Gọn Link Kiếm Tiền Uy Tín</title>
        <meta name="description" content="Rút gọn liên kết kiếm tiền dễ dàng và nhanh chóng với dịch vụ rút gọn URL của chúng tôi. Tạo liên kết ngắn và chia sẻ nó để kiếm thêm thu nhập trực tuyến từ việc chia sẻ liên kết của bạn trên mạng xã hội, blog và website." />
        <meta name="keywords" content="rút gọn liên kết, kiếm tiền, dịch vụ rút gọn URL, liên kết ngắn, kiếm thu nhập trực tuyến, tiếp thị liên kết" />
        <meta property="og:title" content="Rút gọn liên kết kiếm tiền - Dịch vụ rút gọn URL để tạo liên kết ngắn và kiếm thêm thu nhập trực tuyến" />
        <meta property="og:description" content="Rút gọn liên kết kiếm tiền dễ dàng và nhanh chóng với dịch vụ rút gọn URL của chúng tôi. Tạo liên kết ngắn và chia sẻ nó để kiếm thêm thu nhập trực tuyến từ việc chia sẻ liên kết của bạn trên mạng xã hội, blog và website." />
        <meta property="og:url" content="https://hust.media/shop/creative/home" />


      </Helmet>

      <div>

        <div className="mt-0 mx-2">
          <div className="row fixrow">
            <div className="text-center">
              <button className="mx-2 btn btn-primary"
                onClick={() => switch_router('/reactapp/nhatkylink')}
              >
                Lịch sử rút gọn
              </button>
              <button className="mx-2 btn btn-primary"
                onClick={() => switch_router('/reactapp/historybuylink?app=showadview')}
              >
                Nhật ký mua link
              </button>
            </div>
          </div>

          <form className="add-form">
            <div className="mx-1">
              <div className="form-control">
                <Select
                  classNamePrefix="Chọn 1 lựa chọn"
                  onFocus={handleFocus}
                  options={options.map((option) => ({
                    value: option.servicecode,
                    label: `${option.name}`,
                  }))}
                  menuIsOpen={isOpen}
                  isDisabled={isDisabled}
                  onBlur={handleBlur}
                  onMenuOpen={handleMenuOpen}
                  onChange={handleOptionChange}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={false}
                  maxMenuHeight={400}


                />
                <label>Nhập liên kết cần rút gọn</label>
                <br />
                <div className="input-group flex-nowrap">
                  <span className="input-group-text" id="addon-wrapping">
                    url
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Điền link"
                    aria-label="inputlienket"
                    value={inputlienket}
                    name="inputlienket"
                    aria-describedby="addon-wrapping"
                    onChange={e => setinputlienket(e.target.value)}
                  />
                </div>
                <div v-if="comota" >
                  <label>Nhập mô tả liên kết</label>
                  <br />
                  <div className="input-group flex-nowrap">
                    <span className="input-group-text" id="addon-wrapping">Mô tả</span>
                    <input
                      onChange={e => setinputmotat(e.target.value)}
                      value={inputmota} type="text" className="form-control" placeholder="Có thể bỏ trống" aria-label="inputmota" name="inputmota" aria-describedby="addon-wrapping">
                    </input>    </div>
                </div>
                {chedo == 8 && (<>
                  <label className="mt-0 mb-0 flex justify-center items-center">Giá mua link</label>
                  <div className="input-group flex-nowrap">
                    <input
                      onChange={(e) => {
                        setamount(e.target.value);
                      }}
                      value={amount}
                      type="number"
                      className="form-control mb-0"
                      placeholder="Nhập số lượng mong muốn"
                      aria-label="inputcaption"
                      name="inputcaption"
                      aria-describedby="addon-wrapping"
                    ></input>
                  </div>
                  <div className="text-xs mt-[-2px] ">
                    Tối thiểu {service.minorder} &emsp; Tối đa {service.maxorder}
                  </div>
                </>)}
              </div>        </div>
            <div className="mx-2">
              <p className="text-center">
                {content}
              </p>
            </div>
            {window.location.hostname == 'hust.media' &&
              (
                <div className="mt-1 flex flex-wrap  justify-center">
                  <iframe
                    data-aa="2271984"
                    src="//ad.a-ads.com/2271984?size=320x50"
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                    style={{
                      width: '320px',
                      height: '50px',
                      border: 0,
                      padding: 0,
                      overflow: 'hidden',
                      backgroundColor: 'transparent'
                    }}
                  ></iframe>
                  <iframe
                    data-aa="2271984"
                    src="//ad.a-ads.com/2271984?size=320x50"
                    frameBorder="0"
                    scrolling="no"
                    allowFullScreen
                    style={{
                      width: '320px',
                      height: '50px',
                      border: 0,
                      padding: 0,
                      overflow: 'hidden',
                      backgroundColor: 'transparent'
                    }}
                  ></iframe>

                </div>
              )}

            <br></br>
            <button disabled={nutxuly == 1} onClick={handleSubmit}
              className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
              <div className='flex items-center justify-between flex-1'>
                {nutxuly == 1 &&
                  <div className="spinner-border" role="status">

                  </div>}


                <span className='text-lg font-medium text-white'>
                  {nutorder} </span>
                  <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
              </div>
            </button>
          </form>
          {thanhcong2 != '' && <>
            <div className="mx-2 ">
              <div className=" relative py-3 sm:max-w-xl sm:mx-auto">
                <div className=" flex flex-col items-center justify-center">
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-200 to-purple-600 shadow-lg transform rotate-6 rounded-3xl">

                  </div>
                  <div className="rounded-lg flex flex-row justify-between items-center relative px-4 py-4 bg-white shadow-lg sm:rounded-3xl sm:p-20">
                    <h2 className="text-3xl mt-1 text-break font-bold">
                      kết quả: {thanhcong2} </h2>
                    <button onClick={() => saochep(thanhcong2)} className="mt-3 bg-pink-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                      Sao chép
                    </button> </div></div></div></div>
          </>}



        </div>

        <br></br>
      </div>    </>
  )
}

export default Rutgonlink;